import { ChangeEvent, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Button } from '@factorialco/deprecated-design-system'

import DataTable from 'modules/core/components/DataTable'
import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

interface Props {
  search: string
  onSearch: (event: ChangeEvent<HTMLInputElement>) => void
  canCreate: boolean
}

export const MyRequestsDataTable = ({ search, onSearch, canCreate }: Props) => {
  const [open, setOpen] = useState<boolean>(false)
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const onNavigate = (path: string) => {
    setOpen(false)
    navigate(path)
  }
  const onRequestTraining = () => {
    setOpen(!open)
    track(trackingEvents.training.trainingRequest.addTrainingRequest.add, {
      from: 'my_requests',
    })
  }

  return (
    <Box gap="s8">
      <DataTable.HeadBar
        disableDefaultActions
        search={{
          value: search,
          onChange: onSearch,
          placeholder: i18n.t('common.search'),
        }}
        actions={
          canCreate && (
            <Box flexDirection="row" gap="s4">
              <Button.Router
                to={navigation.myTrainings.catalog.fullPath()}
                onClick={() => {
                  track(trackingEvents.training.trainingRequest.gotToTrainingCatalog, {
                    from: 'my_requests',
                  })
                }}
              >
                {i18n.t('trainings.training_requests.my_requests.check_catalog')}
              </Button.Router>
              <PopoverMenu open={open} type="list" onClick={onRequestTraining}>
                <PopoverMenu.Trigger>
                  <Button.Decorative iconName="add" type="secondary">
                    {i18n.t('trainings.my_training.request_trainings_button')}
                  </Button.Decorative>
                </PopoverMenu.Trigger>
                <PopoverMenu.Content side="bottom" align="end">
                  <PopoverMenu.TouchableOption
                    onClick={() => {
                      onNavigate(navigation.myTrainings.catalog.list.fullPath())
                      track(
                        trackingEvents.training.trainingRequest.addTrainingRequest.fromCatalog
                          .start,
                        {
                          from: 'my_requests',
                        }
                      )
                    }}
                    title={i18n.t('trainings.training_requests.create.button.from_catalog')}
                  />
                  <PopoverMenu.TouchableOption
                    onClick={() => {
                      onNavigate(navigation.myTrainings.requests.list.new.fullPath())
                      track(
                        trackingEvents.training.trainingRequest.addTrainingRequest.newProposal
                          .start,
                        {
                          from: 'my_requests',
                        }
                      )
                    }}
                    title={i18n.t('trainings.training_requests.create.button.new')}
                  />
                </PopoverMenu.Content>
              </PopoverMenu>
            </Box>
          )
        }
      />
      <DataTable.Table />
    </Box>
  )
}
